// extracted by mini-css-extract-plugin
module.exports = {"container":"AlertsContainer_container__0sY6J container-large"};